<template>
    <div class="transcoding-progress">
        <div class="spinner"></div>
        <span v-if="isTranscodingAssignedJob && progressPercent > 0" class="transcoding-txt">
            {{ `${progressPercent}%` }}
        </span>
        <span v-else class="transcoding-txt">  {{ $t('words.transcoding_wait') }}</span>
    </div>
</template>

<script>
export default {
    name: 'TranscodingProgressCircle',
    props: {
        mediaContent: {
            type: Object,
            default: () => ({
                transcoding_state: '',
            }),
        },
    },
    computed: {
        transcodingState() {
            return this.mediaContent.transcoding_state;
        },
        progressPercent() {
            return this.mediaContent.transcoding_percent;
        },
        isTranscodingAssignedJob() {
            return this.mediaContent.transcoding_state === 'assigned job';
        },
    },
};
</script>
